import { CommercialPaymentActionType } from './enums';
import { CommercialPaymentAction, CommercialPaymentState } from './interfaces';

export const initialState: CommercialPaymentState = {
	isPaymentLoading: false,
	isPaymentErrored: null,
	paymentList: [],
	totalRecords: 0,

	autoSuggestProjects: [],
	autoSuggestProjectsError: {},

	customerSlipsList: [],
	customerSlipsListLoading: false,
	customerSlipsListError: {},

	paymentSlipsList: [],
	paymentSlipsListLoading: false,
	paymentSlipsListError: {},

	gstInvoiceData: null,
	gstInvoiceLoading: false,
	gstInvoiceError: null
};

export default (state = initialState, { type, payload }: CommercialPaymentAction): CommercialPaymentState => {
	switch (type) {
		case CommercialPaymentActionType.FETCH_ALL_PAYMENTS: {
			return {
				...state,
				isPaymentLoading: true
			};
		}

		case CommercialPaymentActionType.STORE_ALL_PAYMENTS: {
			return {
				...state,
				isPaymentLoading: false,
				paymentList: payload.data, // api response
				// paymentList: payload, // for testing
				totalRecords: payload.totalRecords
			};
		}
		case CommercialPaymentActionType.ERROR_ALL_PAYMENTS: {
			return {
				...state,
				isPaymentLoading: false
			};
		}

		case CommercialPaymentActionType.STORE_PROJECT_AUTOCOMPLETE: {
			return {
				...state,
				autoSuggestProjects: payload.data
			};
		}

		case CommercialPaymentActionType.ERROR_FETCH_PROJECT_AUTOCOMPLETE: {
			return {
				...state,
				autoSuggestProjectsError: payload.error
			};
		}

		case CommercialPaymentActionType.FETCH_CUSTOMER_SLIPS: {
			return {
				...state,
				customerSlipsListLoading: true
			};
		}

		case CommercialPaymentActionType.STORE_CUSTOMER_SLIPS: {
			return {
				...state,
				customerSlipsListLoading: false,
				customerSlipsList: payload
			};
		}

		case CommercialPaymentActionType.ERROR_CUSTOMER_SLIPS: {
			return {
				...state,
				customerSlipsListLoading: false
			};
		}

		case CommercialPaymentActionType.FETCH_PAYMENT_SLIPS: {
			return {
				...state,
				paymentSlipsListLoading: true
			};
		}

		case CommercialPaymentActionType.STORE_PAYMENT_SLIPS: {
			return {
				...state,
				paymentSlipsListLoading: false,
				paymentSlipsList: payload
			};
		}

		case CommercialPaymentActionType.ERROR_PAYMENT_SLIPS: {
			return {
				...state,
				paymentSlipsListLoading: false
			};
		}

		case CommercialPaymentActionType.CREATE_GST_INVOICE: {
			return {
				...state,
				gstInvoiceLoading: true
			};
		}

		case CommercialPaymentActionType.STORE_GST_INVOICE: {
			return {
				...state,
				gstInvoiceLoading: false,
				gstInvoiceData: payload
			};
		}

		case CommercialPaymentActionType.ERROR_GST_INVOICE: {
			return {
				...state,
				gstInvoiceLoading: false,
				gstInvoiceError: payload?.error
			};
		}

		case CommercialPaymentActionType.FETCH_GST_INVOICE: {
			return {
				...state,
				gstInvoiceLoading: true
			};
		}

		default: {
			return state;
		}
	}
};
